import React, { useState, useEffect } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import FileViewer from "react-file-viewer";
import ReactFileViewer from "react-file-viewer";
import { Link } from "react-router-dom";
import axios from "axios";

const FileDisplay = ({ item, onBack}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [file, setFile] = useState(null)

  useEffect(() => {
    fetchDossiers();
  }, [item.user_id, item.id, item]);
  const fetchDossiers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/prouser/update-document/${item.user_id}/${item.id}`
      );

      if (response.status === 200 && response.data.success) {
        // Convert the Base64 string to a Blob
        const byteCharacters = atob(response.data.data.file_attachment); // Decode the Base64 string
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);

          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        const fileType = response.data.data.file_detail
          .split(".")
          .pop()
          .toLowerCase();
        setFileType(fileType);
        // Create a URL for the Blob and set it to the state
        setFile(URL.createObjectURL(blob));

        // setIsDemoOpen(true);
        // setSelectedFile(blob);
        // setFilePreview(response?.data?.filename);
        setFileType(fileType);
        // Create a URL for the Blob and set it to the state
        // setFile(URL.createObjectURL(blob));
      }
    } catch (err) {
      console.log("Error fetching dossiers", err);
    } finally {
      setLoading(false);
    }
  };
  const handleFileError = (error) => {
    console.error("Error viewing file:", error);
    setError(
      "Failed to display the file. It may be corrupted or in an unsupported format."
    );
  };

  return (
    <div className="file-display-container bg-white min-h-screen">
      <div className="p-4 bg-gray-100 border-b flex items-center justify-between">
        <h1 className="text-xl font-bold">Document Viewer</h1>
        <Link
          to="/prouser/esign-des-documents"
          className="bg-primary text-white px-4 py-2 rounded hover:bg-opacity-90"
          onClick={onBack}
        >
          ← Retour à la liste
        </Link>
      </div>

      {loading && (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      )}

      {error && (
        <div className="p-4 m-4 bg-red-100 text-red-700 rounded-md">
          <p className="font-medium">Error:</p>
          <p>{error}</p>
        </div>
      )}

      <div className="file-content h-[calc(100vh-80px)] overflow-auto p-4">
        {!loading && !error && (
          <>
            {fileType === "pdf" && file && (
              <div className="h-full">
                <Worker
                  workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}
                >
                  <Viewer  fileUrl={file} />
                </Worker>
              </div>
            )}

            {(fileType === "docx" || fileType === "doc") && file && (
                 <Worker
                 workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
               >
                 <div
                   className="relative h-full"
                   // onClick={(e) => handlePdfClick(0, e)}
                 >
                   <ReactFileViewer
                     fileType={fileType}
                     filePath={file}
                     onError={(e) => console.log("FileViewer error:", e)}
                   />
                 </div>
               </Worker>
            )}

            {/* For other file types, use the FileViewer */}
            {fileType !== "pdf" &&
              fileType !== "docx" &&
              fileType !== "doc" && (
                <Worker
                  workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
                >
                  <div
                    className="relative h-full"
                    // onClick={(e) => handlePdfClick(0, e)}
                  >
                    <ReactFileViewer
                      fileType={fileType}
                      filePath={file}
                      onError={(e) => console.log("FileViewer error:", e)}
                    />
                  </div>
                </Worker>
              )}
          </>
        )}
      </div>
    </div>
  );
};

export default FileDisplay;
